// extracted by mini-css-extract-plugin
module.exports = {"priceList":"PartnerPrices_priceList__3Zoo3","price":"PartnerPrices_price__2cc1o","soldOut":"PartnerPrices_soldOut__2HKa8"};